<template>
  <w-sliding-popup ref="slidingPopup" title="대시보드 슬라이드쇼 설정" width="700px" @close="closed" :defaultContent="false">
    <div slot="content" class="dashboard-slideshow-setting-content">
      <div class="slideshow-wrapper mr-b20">
        <div class="title-h4 title-bar">
          슬라이드 쇼
          <div class="btn-bar btn-start mr-l15">
            <div class="setting-addel">
              <el-button icon="fas fa-plus" @click="onAddSlideShow"></el-button>
              <el-button icon="fas fa-minus" :disabled="isEmpty(currentSlideshow)" @click="onDeleteSlideShow"></el-button>
            </div>
            <!-- <div>
              <el-button @click="onEditSlideShow">저장</el-button>
              <el-button @click="onAddSlideShow">취소</el-button>
            </div> -->
          </div>
        </div>
        <div class="content-wrapper" style="padding: 0;">
          <el-table
            :data="slideshowData"
            ref="slideshowTable"
            highlight-current-row
            height="calc(100% - 38px)"
            style="widht: 100%"
            class="popup"
            row-class-name="c-dblclick"
            @row-dblclick="onRowDblclick"
            @current-change="slideshowCurrentChange"
          >
            <el-table-column
              prop="slideshowName"
              header-align="left"
              align="left"
              label="이름"
              width="200"
            >
            </el-table-column>
            <el-table-column
              prop="slideshowDesc"
              header-align="left"
              align="left"
              label="설명"
            >
            </el-table-column>
            <el-table-column
              prop="slideshowPlayBtn"
              header-align="left"
              align="center"
              label="실행"
              width="50"
            >
              <template slot-scope="scope">
                <el-dropdown trigger="click" @command="onSlideshow(scope.row, ...arguments)" placement="left">
                  <i class="fas fa-play-circle text-14 c-pointer" v-show="scope.row.slideId"></i>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="frame">프레임</el-dropdown-item>
                    <el-dropdown-item command="fullscreen">전체화면</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="slide-wrapper step-content">
        <div class="tree-box">
          <div class="title-h4 title-bar mr-r10">대시보드</div>
          <div class="content-wrapper">
            <el-scrollbar class="bar-visible">
              <el-tree
                class="dashboard-tree"
                ref="coordDashboardTree"
                :data="treeData"
                :props="defaultProps"
                :node-key="defaultProps.treeKey"
                highlight-current
                :expand-on-click-node="false"
                :default-expand-all="isExpandAll"
              >
              <!-- :filter-node-method="filterNode"
              @node-click="clickNode" -->
              <span class="el-tree-node__label" slot-scope="{ node, data }">
                <span>{{data.label}}</span>
              </span>
              </el-tree>
            </el-scrollbar>
          </div>
        </div>
        <div class="add-btn-box">
          <el-row class="vertical-center-box" style="height:100%;" type="flex" justify="center" align="center">
            <el-tooltip content="슬라이드 추가" placement="top">
              <el-button icon="el-icon-arrow-right" @click="onAddSlide" :disabled="isSlideAddBtnDisabled"></el-button>
            </el-tooltip>
          </el-row>
        </div>
        <div class="drag-box">
          <div class="title-h4 title-bar">
            슬라이드 목록
          </div>
          <div class="content-wrapper">
            <el-scrollbar class="bar-visible">
              <draggable ref="" v-model="slideList" class="list-drag-box" element="ul" @start="isDraggable=true" @end="onEndCallback">
                <li v-for="(element, index) in slideList" :key="element.slideId">
                  <div class="label">{{element.label}}</div>
                  <el-popover
                    ref="slideEditPopover"
                    popper-class="slide-edit-popper"
                    placement="left"
                    width="155"
                    trigger="click"
                    title="대기시간(초)"
                    :visible-arrow="false"
                  >
                    <el-input-number :value="getSlideDelay(index)" @change="setSlideDelay(index, ...arguments)" :min="5" controls-position="right" style="width: 77px;"></el-input-number>
                    <el-button @click="onEditSlide(element, index)">저장</el-button>
                    <span slot="reference"><i :class="['el-icon-edit', 'c-pointer', 'mr-r10']"></i></span>
                  </el-popover>
                  <i :class="['close-icon', 'fal fa-times', 'c-pointer']" @click="onDeleteSlide(element)"></i>
                </li>
              </draggable>
            </el-scrollbar>
          </div>

        </div>
      </div>
    </div>
  </w-sliding-popup>
</template>

<script>
import axios from 'axios';
import draggable from 'vuedraggable';
import DashboardConst from '@/constants/dashboard';
import WDashboardTree from '@/views/dashboard/components/frame/DashboardTree';
import DashboardAPI from '@/api/dashboard/common';
import { isEmpty } from '@/utils/basic';
import max from 'lodash/max';
import find from 'lodash/find';

export default {
  name: 'WDashboardSlideshowSettingPopup',
  components: {
    WDashboardTree,
    draggable,
  },
  data() {
    return {
      isEmpty,
      DashboardConst,
      slideshowData: [],
      treeData: [],
      slideList: [],
      slideDelay: 1,
      currentSlideshow: null,
      isExpandAll: true,
      defaultProps: {
        treeKey: 'treeKey',
        children: 'children',
        label: 'label',
      },
    };
  },
  computed: {
    isSlideAddBtnDisabled() {
      let currentDashboard = null;
      if (!isEmpty(this.$refs.coordDashboardTree)) {
        currentDashboard = this.$refs.coordDashboardTree.getCurrentNode();
      }
      return isEmpty(this.currentSlideshow) || isEmpty(currentDashboard) || (currentDashboard.itemLevel === 'GROUP');
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.SLIDESHOW_SET, this.open);
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.SLIDESHOW_LOAD, this.refreshSlideShowData);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.SLIDESHOW_SET, this.open);
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.SLIDESHOW_LOAD, this.refreshSlideShowData);
  },
  methods: {
    /**
     * 팝업창 오픈
     * @author KangBonghun(toto1323)
     * @return {[type]}      [description]
     */
    open() {
      this.loadData();
      this.$refs.slidingPopup.open();
    },
    /**
     * 팝업창을 닫는다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 팝업창 닫힌 후 호출 됨
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    closed() {
    },
    /**
     * 대시보드 트리 로드
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    loadData() {
      axios.all([
        DashboardAPI.getSlideshowList(),
        DashboardAPI.getDashboardTree(DashboardConst.DASHBOARD_TYPE.COORD),
      ]).then(axios.spread((slideshowResponse, dashboardTreeResponse) => {
        if (!isEmpty(slideshowResponse.data.data) && slideshowResponse.data.success) {
          this.slideshowData = slideshowResponse.data.data;
          this.$nextTick(() => {
            this.$refs.slideshowTable.setCurrentRow(this.slideshowData[0]);
          });
        }
        if (!isEmpty(dashboardTreeResponse.data.data) && dashboardTreeResponse.data.success) {
          this.treeData = dashboardTreeResponse.data.data;
        }
      }));
    },
    refreshSlideShowData() {
      DashboardAPI.getSlideshowList().then((response) => {
        if (response.data.success) {
          this.currentSlideshow = null;
          this.slideshowData = response.data.data;
          this.$nextTick(() => {
            this.$refs.slideshowTable.setCurrentRow(this.slideshowData[0]);
          });
        }
      });
    },
    refreshSlideData(slideshowId) {
      DashboardAPI.getSlideList(slideshowId).then((response) => {
        if (response.data.success) {
          this.slideList = response.data.data;
        }
      });
    },
    onRowDblclick(row) {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.SLIDESHOW_EDIT, {
        editType: '수정',
        slideshowInfo: row,
      });
    },
    onAddSlideShow() {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.SLIDESHOW_EDIT, {
        editType: '추가',
      });
    },
    onDeleteSlideShow() {
      const slideshowId = this.currentSlideshow.slideshowId;
      DashboardAPI.deleteSlideshow(slideshowId).then((response) => {
        if (response.data.success) {
          this.refreshSlideShowData();
          this.refreshSlideData(slideshowId);
          this.$nextTick(() => {
            this.$message({
              message: '슬라이드쇼를 삭제했습니다.',
            });
          });
        } else {
          this.$message({
            message: '슬라이드쇼를 삭제하지 못했습니다.',
          });
        }
      });
    },
    slideshowCurrentChange(slideshow) {
      if (!isEmpty(slideshow)) {
        this.currentSlideshow = slideshow;
        const slideshowId = slideshow.slideshowId;
        this.refreshSlideData(slideshowId);
      }
    },
    onDeleteSlide(element) {
      DashboardAPI.deleteSlide(element.slideshowId, element.dashboardId).then((response) => {
        if (response.data.success) {
          this.refreshSlideShowData();
          this.refreshSlideData(element.slideshowId);
          this.$nextTick(() => {
            this.$message({
              message: '슬라이드를 삭제했습니다.',
            });
          });
        } else {
          this.$message({
            message: '슬라이드를 삭제하지 못했습니다.',
          });
        }
      });
    },
    onAddSlide() {
      const dashboard = this.$refs.coordDashboardTree.getCurrentNode();
      const slideShow = this.currentSlideshow;

      const findItem = find(this.slideList, {
        slideshowId: slideShow.slideshowId,
        dashboardId: dashboard.dashboardId,
      });

      if (!isEmpty(findItem)) {
        this.$message({
          message: '이미 추가된 슬라이드입니다.',
        });
      } else {
        const maxIndex = isEmpty(max(this.slideList, 'orderbyIndex')) ? 0 : max(this.slideList, 'orderbyIndex').orderbyIndex;
        DashboardAPI.addSlide(slideShow.slideshowId, dashboard.dashboardId, 5000, maxIndex + 1).then((response) => {
          if (response.data.success) {
            this.refreshSlideShowData();
            this.refreshSlideData(slideShow.slideshowId);
            this.$nextTick(() => {
              this.$message({
                message: '슬라이드를 추가했습니다.',
              });
            });
          } else {
            this.$message({
              message: '슬라이드를 추가하지 못했습니다.',
            });
          }
        });
      }
    },
    onEndCallback() {
      this.slideList.forEach((slide, index) => {
        slide.orderbyIndex = index + 1;
      });
      this.onEditSlideList();
    },
    onEditSlideList() {
      const slideShow = this.currentSlideshow;
      DashboardAPI.updateSlide(this.slideList).then((response) => {
        if (response.data.success) {
          this.refreshSlideData(slideShow.slideshowId);
          this.$nextTick(() => {
            this.$message({
              message: '슬라이드 순서를 수정했습니다.',
            });
          });
        } else {
          this.$message({
            message: '슬라이드 순서를 수정하지 못했습니다.',
          });
        }
      });
    },
    onSlideshow(slideshow, showType) {
      this.refreshSlideData(slideshow.slideshowId);

      if (showType === 'frame') {
        setTimeout(() => {
          this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.SLIDESHOW_START, this.slideList);
          this.close();
        }, 100);
      } else if (showType === 'fullscreen') {
        this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.COORD_FULL_SCREEN);
        setTimeout(() => {
          this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.SLIDESHOW_START, this.slideList);
          this.close();
        }, 100);
      }
    },
    getSlideDelay(idx) {
      return this.slideList[idx].delay / 1000;
    },
    setSlideDelay(idx, value) {
      this.slideList[idx].delay = value * 1000;
    },
    onEditSlide(slide, idx) {
      if (!isEmpty(slide)) {
        const slideShow = this.currentSlideshow;
        DashboardAPI.updateSlide(slide).then((response) => {
          if (response.data.success) {
            this.refreshSlideData(slideShow.slideshowId);
            this.$refs.slideEditPopover[idx].doClose();
            this.$nextTick(() => {
              this.$message({
                message: '슬라이드를 수정했습니다.',
              });
            });
          } else {
            this.$message({
              message: '슬라이드를 수정하지 못했습니다.',
            });
          }
        });
      }
    },
  },
};
</script>

<style module>

</style>
<style lang="scss">

.dashboard-slideshow-setting-content {
  height: calc(100% - 20px);
  padding: 20px;
  .content-wrapper {
    border: 1px solid #e7e7e7;
    padding: 5px;
    height:calc(100% - 38px);
  }
  .title-bar {
    line-height: 28px;
  }

  .slideshow-wrapper {
    height: 40%;
    .title-bar .btn-bar {
      display: flex;
      justify-content: space-between;
      // width: calc(100% - 90px);
    }
  }
  .slide-wrapper {
    height: 60%;
    .step-view {
      width: 100%;
      height: calc(100% - 163px);
    }

    .step-content {
      width: 100%;
      height: calc(100% - 59px);
    }

    .tree-box {
      display: inline-block;
      float: left;
      height: 100%;
      width: calc(50% - 50px);
    }

    .add-btn-box {
      display: inline-block;
      height: 100%;
      width: 50px;
    }

    .drag-box {
      display: inline-block;
      float: right;
      height: 100%;
      width: 50%;
      text-align: center;
    }

    .close-icon {
      float: right;
      line-height: 28px;
      margin-right: 15px;
    }
  }
  /* 폼 타이틀에 위치하는 컴포넌트 혹은 버튼 위치 */
  .title-btn {
    justify-content: space-between;
    align-items: flex-end;
  }
}
.slide-edit-popper {
  .el-input-number.is-controls-right .el-input__inner {
    padding-left: 10px;
    padding-right: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/DashboardSlideshowSettingPopup.vue